import { Action } from '@canvas/model/permissions';

import { policyAction, type PersistentPolicy } from '../../policy-manager-types.ts';

export const canReadPolicy: PersistentPolicy = {
  id: 'can-read',
  type: 'persistent',
  rule: (state) => {
    const action = policyAction(Action.read);
    if (state.has(action)) {
      return { can: action };
    }
    return { cannot: action };
  },
};
